'use client';

import { Accordion } from '@/components/ui/accordion/accordion';
import { AccordionProvider } from '@/components/ui/accordion/accordion-context';
import { AnimatedList, AnimatedListItem } from '@/components/animations';
import { Heading } from '@/components/ui/heading/heading';
import type { TCity } from '@/shared/types';

type TCityFaqListProps = {
  city: TCity;
  className?: string;
};

/** Local FAQ block (FR-003) using the site's Accordion. Renders nothing if no FAQ entries. */
export const CityFaqList = ({ city, className = '' }: TCityFaqListProps) => {
  if (!city.faq?.length) return null;

  return (
    <section className={className} aria-label={`Najczęstsze pytania – ${city.name}`}>
      <Heading variant="h2" highlight="USA" className="mb-6 text-3xl">
        {`Najczęstsze pytania – import aut z USA do ${city.nameGenitive}`}
      </Heading>

      <AccordionProvider defaultActiveId="city-faq-0">
        <AnimatedList className="flex flex-col gap-4">
          {city.faq.map((item, i) => (
            <AnimatedListItem key={i}>
              <Accordion
                id={`city-faq-${i}`}
                title={item.question}
                titleAs="h3"
                description={item.answer}
              />
            </AnimatedListItem>
          ))}
        </AnimatedList>
      </AccordionProvider>
    </section>
  );
};
